// extracted by mini-css-extract-plugin
export var linkhover = "index-module--linkhover--zdJMW";
export var dentist = "index-module--dentist--KmR9z";
export var image = "index-module--image--a2FPA";
export var noimage = "index-module--noimage--z4I2l";
export var title = "index-module--title--vL2tR";
export var view = "index-module--view--H6JkF";
export var arrow = "index-module--arrow--OCN5o";
export var normal = "index-module--normal--kv0jA";
export var yellow = "index-module--yellow--+GgUC";